import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { AutoTempModes, CoolingModes } from '@library/store/homes/homes.interface';
import { IconComponent } from '@library/ui/atoms/icon/icon.component';
import { HeatingModes } from '@pages/control-page/control-page-store.service';

@Component({
  selector: 'app-home-mode-icon',
  templateUrl: './home-mode-icon.component.html',
  styleUrl: './home-mode-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeModeIconComponent {

  @Input() currentMode: HeatingModes | CoolingModes | AutoTempModes;
  @Input() mode: HeatingModes | CoolingModes | AutoTempModes;
  @Input() icon: string;
  @Input() title: string;
  @Input() titleCancel: string;

  @ViewChild(IconComponent) iconComponent: IconComponent;

  get selected() {
    return this.currentMode === this.mode;
  }

  onEnter() {
    if (this.selected) {
      this.setCloseIcon();
    }
  }

  onLeave() {
    this.resetIcon();
  }

  onClick() {
    if (this.selected) {
      this.resetIcon();
    }
    else {
      this.setCloseIcon();
    }
  }

  private resetIcon() {
    this.iconComponent.name = this.icon;
  }

  private setCloseIcon() {
    this.iconComponent.name = 'close';
  }
}
